module.exports = __webpack_public_path__ + "img/placeholder-nodata.a1bbc79c.png";